(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-buy-buttons"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    constructor() {
      super()
      this.inputElement = this.querySelector('input')
      this.#prepareEventHandlers()
    }

    #prepareEventHandlers() {
      const minusButton = this.querySelector('[name="minus"]')
      const plusButton = this.querySelector('[name="plus"]')

      ;[minusButton, plusButton].forEach(button => {
        button.addEventListener('click', this.#onButtonClick)
      })
    }

    #onButtonClick = event => {
      event.preventDefault()
      const currentValue = parseInt(this.inputElement.value)
      const newValue = event.target.name === 'plus' ? currentValue + 1 : currentValue - 1
      this.inputElement.value = newValue > 0 ? newValue : 1
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput)
  }

  document.addEventListener('DOMContentLoaded', function () {
    const buyButton = document.querySelector('.product-buy-buttons')
    const stickyButton = document.querySelector('.sticky-button')
    const buyButtonOffset = buyButton.offsetTop

    window.addEventListener('scroll', function () {
      if (window.scrollY >= buyButtonOffset + 100) {
        stickyButton.classList.add('sticky-button-fixed')
      } else {
        stickyButton.classList.remove('sticky-button-fixed')
      }
    })

    document.addEventListener('click', function (event) {
      if (event.target.closest('.sticky-button')) {
        window.scrollTo({
          top: buyButton.offsetTop - 200,
          behavior: 'smooth'
        })
      }
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-quantity-selector"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    constructor() {
      super()
      this.inputElement = this.querySelector('input')
      this.#prepareEventHandlers()
    }

    #prepareEventHandlers() {
      const minusButton = this.querySelector('[name="minus"]')
      const plusButton = this.querySelector('[name="plus"]')

      ;[minusButton, plusButton].forEach(button => {
        button.addEventListener('click', this.#onButtonClick)
      })
    }

    #onButtonClick = event => {
      event.preventDefault()
      const currentValue = parseInt(this.inputElement.value)
      const newValue = event.target.name === 'plus' ? currentValue + 1 : currentValue - 1
      this.inputElement.value = newValue > 0 ? newValue : 1
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput)
  }
  } catch(e) { console.error(e); }
})();

})();
